(function () {
  'use strict';

  angular.module('app.dashboard.to-do-list', []);

})();
